export default "__VITE_ASSET__CGtTPE5g__"